module.exports = __webpack_public_path__ + "static/img/medicalc.b35698c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/medicalc.png
// module id = 19cR
// module chunks = 1